import { Button, Form, Modal, Select } from 'antd';
import { useChangeConsultantMutation } from 'app/services/edpApiV1/consultations';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import React, { useEffect, useState } from 'react';

import { useNotifications } from 'shared/hooks/use-notifications';

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  allSubordinates: {
    id: number;
    lastName: string | null;
    middleName: string | null;
    name: string | null;
    organizationId: string | null;
    roleName: string | null;
  }[];
  requestId: number;
  consultantIdCurrent?: number;
};

const ModalConsultationsSubordinates = ({
  allSubordinates,
  openModal,
  setOpenModal,
  requestId,
  consultantIdCurrent,
}: TProps) => {
  const [btnState, setBtnState] = useState<boolean>(true);
  const [form] = Form.useForm();
  const [changeConnsultantTrigger, result] = useChangeConsultantMutation();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const { isSuccess, isError, reset } = result;

  const handleOk = () => {
    setOpenModal(false);
  };

  const handleCancel = () => {
    setOpenModal(false);
    form.resetFields();
    setBtnState(true);
  };

  const onSelect = (hr: number) => {
    setBtnState(false);
    if (hr === consultantIdCurrent) setBtnState(true);
  };

  const onFinish = (values: { hrId: number }) => {
    const { hrId } = values;
    const bodyRequest = {
      chatId: requestId,
      consultantId: hrId,
    };
    changeConnsultantTrigger(bodyRequest);
    setOpenModal(false);
    form.resetFields();
    setBtnState(true);
  };

  useEffect(() => {
    if (consultantIdCurrent) {
      form.setFieldsValue([{ name: 'hrId', value: consultantIdCurrent }]);
    }
  }, [form, consultantIdCurrent]);

  useNotifications(isSuccess, isError, 'Ответственный назначен', 'Что-то пошло не так', reset);

  return (
    <Modal
      title="Выберите ответственного сотрудника"
      footer={false}
      onOk={handleOk}
      onCancel={handleCancel}
      visible={openModal}
    >
      <Form form={form} name="changeResponsible" onFinish={onFinish}>
        <Form.Item
          name="hrId"
          rules={[
            {
              validator: async (_, v) => {
                if (v === consultantIdCurrent) return Promise.reject();
              },
              message: 'Выберите нового ответственного',
            },
          ]}
        >
          <Select placeholder="Выберите из списка" onSelect={onSelect}>
            {allSubordinates.map(({ id, name, middleName, lastName }) => (
              <Select.Option key={id} value={id}>
                {`${lastName} ${name} ${middleName ?? ''}`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {!allAvailableOrganizations && (
          <Form.Item>
            <Button htmlType="submit" type="primary" disabled={btnState}>
              Назначить
            </Button>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default ModalConsultationsSubordinates;
